import { LOGIN_TYPE_WEBLOGIN, STORE_KEY_LOGIN_TYPE } from 'Constants/'
import { modalCheckupState } from './state'
import { logAppError } from 'Helpers/logger'
import { storeGet } from 'Helpers/localStorage'
import {
  addSilencedAlerts,
  fastCheck,
  getEntitiesThatUseMessage,
  getSilencedAlerts,
  getWhitelist,
  isSendingMessage,
  modalCheck,
  updateWhitelist
} from './actions'
import { EmailMessageCheckUpIssueType } from 'Constants'
import { pendoTrack } from 'Helpers/pendoTracking'

export const callbackAddToWhiteList = ({
  set,
  snapshot
}) => async idMessage => {
  set(modalCheckupState, prev => ({ ...prev, error: false }))
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const {
    addToWhiteList,
    silencedCheck,
    blockToDisplay
  } = await snapshot.getPromise(modalCheckupState)

  try {
    if (silencedCheck) {
      const silencedAlerts = await getSilencedAlerts()
      const silencedAlertsArrayUpdated =
        silencedAlerts.DataValue && silencedAlerts.DataValue !== ''
          ? JSON.parse(silencedAlerts.DataValue)
          : []
      // mostrati e da disabilitare per il messaggio corrente
      // const displayed = objArray.filter(e => e.shown)
      blockToDisplay.forEach(e => {
        const index = silencedAlertsArrayUpdated.findIndex(
          f => f.issueType === e.issueType
        )
        if (index > -1) {
          // faccio il push nel disableForMessage se non esiste
          const exsist = silencedAlertsArrayUpdated[
            index
          ].disableForMessage.includes(idMessage.toString())
          if (!exsist) {
            silencedAlertsArrayUpdated[index].disableForMessage.push(
              idMessage.toString()
            )
          }
        } else {
          const obj = {
            issueType: e.issueType,
            disableForMessage: [idMessage.toString()]
          }
          silencedAlertsArrayUpdated.push(obj)
        }
      })
      if (loginType === LOGIN_TYPE_WEBLOGIN) {
        await addSilencedAlerts(silencedAlertsArrayUpdated)
      }
    }
    if (loginType === LOGIN_TYPE_WEBLOGIN) {
      await updateWhitelist(idMessage, addToWhiteList)
    }
  } catch (error) {
    logAppError({
      appError: error
    })
    set(modalCheckupState, prev => ({ ...prev, error: true }))
  }
}

export const showModalIfNecessaryCallback = ({ set }) => async idMessage => {
  set(modalCheckupState, prev => ({
    ...prev,
    error: false,
    isFethingModalState: true
  }))

  try {
    const isSending = await isSendingMessage(idMessage)
    if (!isSending) {
      // modal check & silenced alerts
      const [
        mdCheck,
        workflows,
        silencedAlerts,
        whiteList,
        checkup
      ] = await Promise.all([
        modalCheck(idMessage),
        getEntitiesThatUseMessage(idMessage),
        getSilencedAlerts(),
        getWhitelist(idMessage),
        fastCheck(idMessage)
      ])

      const silencedAlertsArray =
        silencedAlerts.DataValue && silencedAlerts.DataValue !== ''
          ? typeof JSON.parse(silencedAlerts.DataValue) === 'string'
            ? []
            : JSON.parse(silencedAlerts.DataValue)
          : []

      if (silencedAlertsArray.length > 0) {
        silencedAlertsArray.forEach(e => {
          e.silenced =
            e.disableForMessage.length > 0
              ? e.disableForMessage.includes(idMessage.toString())
              : !e.enable
        })
      }
      Object.keys(EmailMessageCheckUpIssueType).forEach(e => {
        const index = silencedAlertsArray.findIndex(
          f => f.issueType === EmailMessageCheckUpIssueType[e]
        )
        if (index === -1) {
          const obj = {
            silenced: false,
            issueType: EmailMessageCheckUpIssueType[e]
          }
          silencedAlertsArray.push(obj)
        }
      })
      set(modalCheckupState, prev => ({
        ...prev,
        silencedAlertsArray: silencedAlertsArray
      }))
      // visualizza la modale
      // in base ai campi dinamici
      // - opzione attiva
      // - campi sbagliati
      let showModal = false
      let newWrongTags = []
      if ('CheckFields' in mdCheck) {
        const seeOption =
          mdCheck.CheckFields.IsDynamicFieldsEnabled === false &&
          mdCheck.CheckFields.ContainsDynamicFields === true
        set(modalCheckupState, prev => ({
          ...prev,
          dynamicFieldsOptionEnabled: seeOption
        }))
        showModal = seeOption

        if (mdCheck.CheckFields.WrongDynamicTags.length > 0) {
          const whitelisted =
            whiteList.DataValue && whiteList.DataValue !== ''
              ? JSON.parse(whiteList.DataValue)
              : []

          newWrongTags = mdCheck.CheckFields.WrongDynamicTags.slice(0)
          newWrongTags = newWrongTags.filter(m => m.Value !== '[]')
          // pendo
          newWrongTags.forEach(e => {
            const pendoProps = {
              IdMessage: idMessage,
              Value: e.Value.replace(/[[\]]/g, ''),
              Location: e.Location,
              // ===
              //  'Header'
              //   ? 'Subject'
              //   : e.Location ===
              //   'Summary'
              //     ? 'Summary'
              //     : 'Body',
              SilentMode: whitelisted.includes(e.Value.replace(/[[\]]/g, '')),
              AlertStatus: 'Enabled',
              Source: 'overview'
            }
            pendoTrack('Checkup - dynamic field - impression', pendoProps)
          })
          const tmpWhiteListItems = []
          whitelisted.forEach(element => {
            const i = newWrongTags.findIndex(
              e => e.Value.replace(/[[\]]/g, '') === `${element}`
            )
            if (i > -1) {
              newWrongTags.splice(i, 1)
              tmpWhiteListItems.push(element)
            }
          })

          set(modalCheckupState, prev => ({
            ...prev,
            wrongDynamicTags: newWrongTags,
            addToWhiteList: tmpWhiteListItems
          }))
          /* opzione disabilitata */
          if (!showModal) {
            /* prendo in considerazione i campi sabgliati */
            showModal = newWrongTags.length > 0
          }
        }
      }

      if (mdCheck) {
        set(modalCheckupState, prev => ({
          ...prev,
          checkBlacklistResult: mdCheck.CheckBlacklistResult,
          checkLiquidCode: mdCheck.CheckLiquidCode,
          checkAttachments: mdCheck.CheckAttachments,
          checkDynamicContents: mdCheck.CheckDynamicContents,
          checkSize: mdCheck.CheckSize,
          checkContent: mdCheck.CheckContent,
          checkLinksWoTracking: mdCheck.CheckLinksWoTracking,
          checkUnsubscribeLink: mdCheck.CheckUnsubscribeLink,
          checkMaxSize: mdCheck.CheckMaxSize,
          checkPreheader: mdCheck.CheckPreheader,
          checkWebAnalytics: mdCheck.CheckWebAnalytics,
          checkWorkflowWarning: workflows,
          checkCustomDomainCustomizable: mdCheck.CustomDomainCustomizable
        }))
      }
      // BLICCHI DA MOSTRARE IN BASE
      // AI SETTINGS E AGLI ALERTS
      // improvements
      const PreheaderInfo =
        !mdCheck.CheckPreheader &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.PreheaderInfo
        ).silenced
      const WebAnalyticsTrackingInfo =
        !mdCheck.CheckWebAnalytics &&
        !silencedAlertsArray.find(
          e =>
            e.issueType ===
            EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo
        ).silenced
      // potential
      const LinkTrackingWarning =
        !mdCheck.CheckLinksWoTracking &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.LinkTrackingWarning
        ).silenced

      const UnsubscribeLinkWarning =
        !mdCheck.CheckUnsubscribeLink &&
        !silencedAlertsArray.find(
          e =>
            e.issueType === EmailMessageCheckUpIssueType.UnsubscribeLinkWarning
        ).silenced

      const MaxSizeInfo =
        !mdCheck.CheckMaxSize.Check &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.MaxSizeInfo
        ).silenced

      const BlackListUrlWarning =
        mdCheck.CheckBlacklistResult.Action === 1 &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.BlackListUrlWarning
        ).silenced

      const WorkflowWarning =
        workflows &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.WorkflowWarning
        ).silenced

      const LinkCheckWarning = !silencedAlertsArray.find(
        e =>
          e.issueType ===
            EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo ||
          e.issueType === EmailMessageCheckUpIssueType.PreheaderInfo
      ).silenced

      const DynamicFieldsWarning =
        newWrongTags &&
        newWrongTags.length > 0 &&
        !silencedAlertsArray.find(
          e => e.issueType === EmailMessageCheckUpIssueType.DynamicFieldsWarning
        ).silenced

      const objArray = [
        {
          key: 'LinkCheckWarning',
          issueType: 6,
          toDisplay: LinkCheckWarning,
          section: 'INFO'
        },
        {
          key: 'LinkTrackingWarning',
          issueType: 7,
          toDisplay: LinkTrackingWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'UnsubscribeLinkWarning',
          issueType: 8,
          toDisplay: UnsubscribeLinkWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'DynamicFieldsWarning',
          issueType: 9,
          toDisplay: DynamicFieldsWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'WorkflowWarning',
          issueType: 10,
          toDisplay: WorkflowWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'BlackListUrlWarning',
          issueType: 11,
          toDisplay: BlackListUrlWarning,
          section: 'POTENTIAL'
        },
        {
          key: 'PreheaderInfo',
          issueType: 12,
          toDisplay: PreheaderInfo,
          section: 'INFO'
        },
        {
          key: 'MaxSizeInfo',
          issueType: 13,
          toDisplay: MaxSizeInfo,
          section: 'POTENTIAL'
        },
        {
          key: 'WebAnalyticsTrackingInfo',
          issueType: 14,
          toDisplay: WebAnalyticsTrackingInfo,
          section: 'INFO'
        }
      ]
      // [
      //   {
      //     "issueType": 9,
      //     "disableForMessage": [],
      //     "enable": true
      //   }
      // ]
      // mostrati e, eventualmente,
      // da disabilitare per il messaggio corrente
      const toDisplay = objArray.filter(e => e.toDisplay)
      set(modalCheckupState, prev => ({
        ...prev,
        blockToDisplay: toDisplay,
        checkup
      }))

      // show modal if error
      if (
        (checkup &&
          (checkup.blocking > 0 ||
            checkup.potential > 0 ||
            checkup.improvements > 0)) ||
        showModal
      ) {
        toDisplay.length > 0 &&
          set(modalCheckupState, prev => ({
            ...prev,
            show: true
          }))
      }
    } else {
      // show modal BeingSent
      set(modalCheckupState, prev => ({
        ...prev,
        show: false,
        showModalBeingSent: true
      }))
    }
  } catch (error) {
    logAppError({
      appError: error
    })
    set(modalCheckupState, prev => ({ ...prev, error: true }))
  }
  set(modalCheckupState, prev => ({ ...prev, isFethingModalState: false }))
}

export const sendingMessageCallback = ({ set }) => async id => {
  set(modalCheckupState, prev => ({ ...prev, error: false }))
  try {
    const isSending = await isSendingMessage(id)
    return isSending
  } catch (error) {
    logAppError({
      appError: error
    })
    set(modalCheckupState, prev => ({ ...prev, error: true }))
  }
}
